module.exports = __webpack_public_path__ + "static/media/logo_lab51.26a07ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_lab51.png
// module id = 739
// module chunks = 0